import BasePage from  './basePage';
import VideoPlayer from "promokit-youtubeplayer";

export default class Legend3 extends BasePage{
  constructor(info){
    super(info);
    this.showMotion;
    this.player = new VideoPlayer({
      el: "#legend3-video",
      videoId: "rlShUOPS7nE",
      loop: false,
      autoplay: false
    });
    this._motionSet();

  }
  _motionSet(){
    this.showMotion = new TimelineMax({paused: true, onComplete: this._showCompleteContent, onCompleteParams: [this]});
    this.showMotion
      .fromTo(this.ele.querySelector('.chr-1'), 3, {autoAlpha:0, x:-400}, {autoAlpha:1, x:0, ease: 'chr'}, '+=0.5')
      .fromTo(this.ele.querySelector('.chr-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeInOut}, '-=2')
      .fromTo(this.ele.querySelector('.chr-2'), 3, {autoAlpha:0, x:400}, {autoAlpha:1,  x:0, ease: 'chr'}, '-=3')
      .fromTo(this.ele.querySelector('.chr-2>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeInOut}, '-=2')
      .addLabel('obj', '-=2')
      .fromTo(this.ele.querySelector('.txt-1'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, '-=2')
      .fromTo(this.ele.querySelector('.txt-2'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, '-=1.7')
      .fromTo(this.ele.querySelector('.txt-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeOut}, '-=1')
      .fromTo(this.ele.querySelector('.player-con'), 1, {autoAlpha:0}, {autoAlpha:1, ease: Quart.easeOut}, '-=1.2')
      .fromTo(this.ele.querySelector('.icon-scroll'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:0.8, y:0, ease: Quart.easeOut}, '-=0.4')

      .fromTo(this.ele.querySelector('.obj-1 dt'), 1.5, {autoAlpha:0, y:-70}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj')
      .fromTo(this.ele.querySelector('.obj-1 .bg'), 0.7, {autoAlpha:0, scale:0.2}, {autoAlpha:1,  scale:1, ease: Expo.easeOut}, 'obj+=0.4')
      .fromTo(this.ele.querySelector('.obj-1 dt span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Expo.easeIn}, 'obj+=0.5')
      .fromTo(this.ele.querySelector('.obj-1 .txt'), 1, {autoAlpha:0, y:20}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=1')

      .fromTo(this.ele.querySelector('.obj-2 dt'), 1.5, {autoAlpha:0, y:-70}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj')
      .fromTo(this.ele.querySelector('.obj-2 .bg'), 0.7, {autoAlpha:0, scale:0.2}, {autoAlpha:1,  scale:1, ease: Expo.easeOut}, 'obj+=0.4')
      .fromTo(this.ele.querySelector('.obj-2 dt span'), 1, {autoAlpha:1}, {autoAlpha:0, ease:  Expo.easeIn}, 'obj+=0.5')
      .fromTo(this.ele.querySelector('.obj-2 .txt'), 1, {autoAlpha:0, y:20}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=1')

    //this.player.stop();
  };
  show(size, dx){
    super.show(size, dx)
    this.showMotion.seek(0)
    this.showMotion.play();
    TweenMax.set(this.ele, {autoAlpha:1});
  }
  hide(size, dx, moveSec){
    super.hide(size, dx, moveSec)
    this.showMotion.pause();
    TweenMax.to(this.ele, 0.5, {autoAlpha:0});
    this.player.pause();
  }
  _showCompleteContent(thisv){
    // thisv.player.mute();
    //  thisv.player.play();
  }
}



// WEBPACK FOOTER //
// ./src/js/page/legend3.js